import type { CombinedError } from '@urql/core';

export const VERIFICATION_STEPS = <const>{
  AUTH_METHOD_INPUT: 'auth_method_input',
  PINCODE_INPUT: 'pincode',
  SUCCESS: 'success',
};
export type VerificationSteps = (typeof VERIFICATION_STEPS)[keyof typeof VERIFICATION_STEPS];

export const VERIFICATION_TYPES = <const>{
  PHONE: 'phone',
  // EMAIL: 'email',
};

export type VerificationTypes = (typeof VERIFICATION_TYPES)[keyof typeof VERIFICATION_TYPES];

export interface VerificationFlowEmits {
  verified: [];
}

export interface VerificationResponse {
  success: boolean;
  error: CombinedError | null;
}
